<script>
    export let title;
    export let content;
</script>

<div class="box">
    <div classes="{title} is-centered">{title}</div>
    <div class="card-content">
        {content}
    </div>
</div>

<style lang="scss">
    .box {
        text-align: center;
    }
</style>
